export default "__VITE_ASSET__0a554197__"